import { z } from "zod";

export const firstLoginSchema = z.object({
	first_name: z.string().trim().min(1, "First name is required.").max(120),
	last_name: z.string().trim().min(1, "Last name is required.").max(120),
});

export type FirstLoginValues = z.infer<typeof firstLoginSchema>;
